// Explicit stable field names only. Financial/account fields are never candidates.
export function profileAnswers(profile,fields){
 const names=new Set(fields.map(f=>f.name));
 const values={full_name:profile.full_name,name:profile.full_name,first_name:profile.first_name,last_name:profile.last_name,email:profile.email,phone:profile.phone,mobile:profile.mobile,landline:profile.landline,mobile_phone:profile.mobile,landline_phone:profile.landline,country:profile.country};
 return Object.fromEntries(Object.entries(values).filter(([k,v])=>names.has(k)&&typeof v==="string"&&v.trim()));
}
export function fillBlankAnswers(current,values,touched=new Set()){
 const next={...current};for(const [key,value] of Object.entries(values))if(!touched.has(key)&&(next[key]===undefined||next[key]===null||next[key]===""))next[key]=value;
 return next;
}
